import VueApollo from 'vue-apollo';
import { apolloBoot } from '@nitra/components/njs/apollo.js';
import { getToken } from '@nitra/components/njs/token.js';
const consola = createLogger(__filename);

// для використання GraphQL в інших js
export { apolloClient } from '@nitra/components/njs/apollo.js';
export default async ({
  app,
  Vue
}) => {
  if (!getToken()) {
    consola.debug('Skip Apollo boot');
    return;
  }
  consola.debug('Start Apollo boot');
  const apolloProvider = apolloBoot();
  Vue.use(VueApollo);
  app.apolloProvider = apolloProvider;
  consola.debug('End Apollo boot');
};